import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAiTrainerAuth } from '@/contexts/AiTrainerAuthContext';

/**
 * Route guard for trainer-only pages.
 *
 * Behaviour:
 *   - Initial /auth/me still in flight → spinner.
 *   - No user                         → redirect to /login.
 *   - status='pending' or 'disabled'  → redirect to /pending.
 *   - status='active'                 → render children.
 */
const RequireTrainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, ready } = useAiTrainerAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <Loader2 size={24} className="animate-spin text-[#1a5276]" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.status !== 'active') {
    return <Navigate to="/pending" replace />;
  }
  return <>{children}</>;
};

export default RequireTrainer;
